import { action } from 'typesafe-actions';
import { MapLocalActionTypes } from './types';

export const queryFeatureLayerExtentStart = (
  layer: __esri.SceneLayerCapabilitiesOperations
) =>
  action(MapLocalActionTypes.QUERY_FEATURE_LAYER_EXTENT_START, {
    layer
  });
export const queryFeatureLayerExtentSuccess = (payload: any) =>
  action(MapLocalActionTypes.QUERY_FEATURE_LAYER_EXTENT_SUCCESS, payload);
export const queryFeatureLayerExtentFailure = (payload: any) =>
  action(MapLocalActionTypes.QUERY_FEATURE_LAYER_EXTENT_FAILURE, payload);

export const queryClusterExtentStart = (
  layerView: __esri.LayerView,
  objectId: number,
  isAggregate: boolean
) =>
  action(MapLocalActionTypes.QUERY_CLUSTER_EXTENT_START, {
    layerView,
    objectId,
    isAggregate
  });
export const queryClusterExtentSuccess = (payload: any) =>
  action(MapLocalActionTypes.QUERY_CLUSTER_EXTENT_SUCCESS, payload);
